import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import HotelSettingsMyotbMyotbBaseController from 'lumen/controllers/hotel/settings/myotb/myotb-base';
import { STAGES } from 'lumen/utils/constants/otb-selfservice-constants';

export default class HotelSettingsMyotbIntroController extends HotelSettingsMyotbMyotbBaseController {
  @service declare access: Services['access'];
  @service declare router: Services['router'];

  pageName = STAGES.INTRO_PAGE;

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get hasBenchmarkQuestion() {
    return this.access.hasFeature('otb.benchmark_question.view');
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get isSelfServiceFlowEnabled() {
    // @ts-expect-error: Object is possibly 'null'.
    return this.router.currentRouteName.includes(
      'hotel.settings.myotb.intro.index',
    );
  }

  @action onClickNext(): void {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    this.router.legacyTransitionTo('hotel.settings.myotb.pms-selection');
  }
}
